import axios from 'axios';

function OverlayShape(data, fromFlagship = false) {
  if (fromFlagship) {
    // Shapes are defined different when coming from flagship
    this.createFromFlagshipData(data)
  } else {
    this.Id = data.Id;
    this.OverlayId = data.OverlayId;
    this.OverlayName = data.OverlayName;
    this.Name = data.Name;

    // reparse the WKT string to be compatible with Google Maps
    if (data.Wkt) {
      let points = data.Wkt.replace("POLYGON((", "").replace("))", "").split(",");
      let new_points = [];
      let new_geo = "polygon(";
      points.forEach(function(point) {
        let coords = point.split(" ");
        new_points.push(coords[1] + " " + coords[0])
      })
      new_geo += new_points.join(",") + ")";
      this.Geometry = new_geo;
    } else if (data.Geometry) {
      this.Geometry = data.Geometry;
    }
    this.Color = data.Color;
  }
}

OverlayShape.prototype = {
  constructor: OverlayShape,
  createFromFlagshipData: function(data) {
    this.Id = data.db2_tech_id.replace('x','').replaceAll("'",'');
    this.OverlayId = data.OverlayId;
    this.OverlayName = data.OverlayName;
    this.Name = data.label;
    this.Color = data.color;

    // reparse the WKT string to be compatible with Google Maps
    if (data.wkt) {
      let points = data.wkt.replace("MULTIPOLYGON(((", "")
      points = points.substring(0,points.lastIndexOf(',')).split(",");
      let new_points = [];
      let new_geo = "polygon('";
      points.forEach(function(point) {
        let coords = point.split(" ");
        new_points.push(coords[1] + " " + coords[0])
      })
      new_geo += new_points.join(",") + "')";
      this.Geometry = new_geo;
    } else if (data.Geometry) {
      this.Geometry = data.Geometry;
    }
  }
};


OverlayShape.find = function(ids) {
  var deferred = $.Deferred();

  if(!Array.isArray(ids)){
    ids = [ids];
  }

  var filter = "Id Eq " + ids.join(',')

  axios.get(window.routes.shapes_overlays_path(), {
    params: {_filter: filter}
  }).then((response) => {
    var shapes = [];
    response.data.forEach(function(shape) {
      shapes.push(new OverlayShape(shape));
    });
    deferred.resolve(shapes);    
  });

  return deferred;
}

export default OverlayShape;
